import { Info } from "lucide-react";
import { COMPANY } from "../../lib/data";

const FULL_TEXT = `The figures, projections, and comparisons produced by this tool are illustrative estimates generated from the assumptions you enter combined with generalized industry models. They are provided for informational and planning purposes only and do not constitute a quote, offer, guarantee, warranty, or promise of any specific savings, cost, performance, timeline, or result. Actual outcomes vary based on site conditions, usage, product handling, market pricing, and other factors outside ${COMPANY.legal}'s control. Nothing shown here should be relied upon as financial, engineering, legal, or professional advice. Consult your ${COMPANY.legal} representative and appropriate qualified professionals before making purchasing or operational decisions.`;

// Prominent, bordered disclaimer for interactive tools/calculators.
export function ModelingDisclaimer({ dark = false, testid = "modeling-disclaimer" }) {
  return (
    <div
      data-testid={testid}
      className={`flex items-start gap-3 p-4 border ${
        dark ? "border-white/15 bg-white/[0.03] text-white/60" : "border-border bg-muted text-muted-foreground"
      }`}
    >
      <Info className={`h-4 w-4 flex-shrink-0 mt-0.5 ${dark ? "text-flame" : "text-flame"}`} />
      <p className="text-[11px] leading-relaxed">
        <span className={`font-semibold ${dark ? "text-white/80" : "text-charcoal"}`}>
          Estimates only — not a guarantee.{" "}
        </span>
        {FULL_TEXT}
      </p>
    </div>
  );
}

// Compact single-line footnote for print/PDF-style briefs.
export function ModelingDisclaimerNote({ prefix = "", className = "" }) {
  return (
    <p className={`text-[8px] leading-relaxed text-muted-foreground ${className}`}>
      {prefix}
      {prefix ? " " : ""}
      Illustrative model for informational purposes only — not a quote, guarantee, or warranty of any specific
      result. Actual figures vary by site conditions, usage, handling &amp; market pricing. Not financial,
      engineering, or legal advice. © {new Date().getFullYear()} {COMPANY.legal}.
    </p>
  );
}

export default ModelingDisclaimer;
